module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 0.56469","quantity":0.00565},{"color":"#9dc4b5","label":" 0.56469- 0.56469","quantity":0.00565},{"color":"#e6efc3","label":" 0.56469- 0.56469","quantity":0.00565},{"color":"#ffe89e","label":" 0.56469- 0.675","quantity":0.00675},{"color":"#f5af7f","label":" 0.675- 1.32138","quantity":0.01321},{"color":"#ed6d32","label":" 1.32138- 12.97109","quantity":0.12971}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/fxfl_raster/rice_MME_1981_2016_lcr_70_return_10.json
// module id = MKOo
// module chunks = 171